import axios from 'axios';
import { decodeUserEmail, getAuthHeader, } from './utils/authHelper';
import { isUnauthorized } from './utils/responseValidator';
import { getEnv } from '../utils/envUtils';

const AUTH_SERVICE_URL = getEnv('REACT_APP_AUTH_API');
const STATE = encodeURIComponent(getEnv('REACT_APP_AUTH_STATE'));
const PERMISSION_MODULE = getEnv('REACT_APP_PERMISSION_MODULE');

const request = (uriPath, method, params) => axios({
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: getAuthHeader(),
    },
    method: method ?? 'GET',
    url: `${AUTH_SERVICE_URL}/${uriPath}`,
    withCredentials: true,
    ...params,
});
const login = () => request(`auth/login?state=${STATE}`);

const refresh = async () =>
    request('auth/refresh')
        .then(({ data: token }) => {
            storeToken(token);
            return getUserData(token);
        });

const refreshAndRetry = (err, requestBuilder) => new Promise(((resolve, reject) => {
    if (isUnauthorized(err.response)) {
        refresh()
            .then(() => {
                axios(requestBuilder())
                    .then(response => resolve(response))
                    .catch(innerErr => reject(innerErr));
            })
            .catch(innerErr => reject(innerErr));
    } else {
        reject(err);
    }
}));

const storeToken = (token) => localStorage.setItem('token', JSON.stringify(token));

const loggedIn = async (token) => {
    storeToken(token);
    return await getUserData(token);
};

const getUserData = async (token) => {
    const claims = await request('users/claims');
    const email = await decodeUserEmail(token);
    const permissions = await getPermissions(claims.data.id);

    const matchPermission = (permissionId) => (item) => item.permission === permissionId && item.module.toLowerCase() === PERMISSION_MODULE.toLowerCase();

    return {
        email,
        isBasicUser: permissions.data.some(matchPermission(108)),
        isAdvancedUser: permissions.data.some(matchPermission(109)),
        isAnalyzeUser: permissions.data.some(matchPermission(110)),
        username: email,
    };
};

const getPermissions = async (userId) =>
    request(`permissions?userId=${userId}&module=${PERMISSION_MODULE}`);

const api = {
    login,
    loggedIn,
    refresh,
    refreshAndRetry,
};

export default api;
